module.exports = __webpack_public_path__ + "static/media/chingo-dental-logo.085ccd05.png";